import React, { lazy, Suspense } from 'react';

import clientOnly from '../../../hoc/clientOnly';

const QuoteCarousel = lazy(() =>
  import(/* webpackChunkName: "QuoteCarousel" */ './QuoteCarousel')
);

const Loader = props => (
  <Suspense fallback={null}>
    <QuoteCarousel {...props} />
  </Suspense>
);

export default clientOnly(Loader);
